<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
		<g id="Group_30552" data-name="Group 30552" transform="translate(-1567.001 -310)">
			<g id="Component_68_3600" data-name="Component 68 – 3600" transform="translate(1567.001 310)">
				<rect id="Rectangle_9086" data-name="Rectangle 9086" width="28" height="28" rx="8" fill="transparent" />
			</g>
			<line
				id="Line_876"
				data-name="Line 876"
				x2="11.306"
				transform="translate(1576.001 317.999)"
				fill="none"
				stroke="#5a677d"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.2"
			/>
			<line
				id="Line_877"
				data-name="Line 877"
				x2="11.306"
				transform="translate(1576.001 323.529)"
				fill="none"
				stroke="#5a677d"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.2"
			/>
			<line
				id="Line_878"
				data-name="Line 878"
				x2="7.34"
				transform="translate(1576 320.764)"
				fill="none"
				stroke="#5a677d"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.2"
			/>
			<line
				id="Line_879"
				data-name="Line 879"
				x2="7.34"
				transform="translate(1576 326.293)"
				fill="none"
				stroke="#5a677d"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.2"
			/>
			<line
				id="Line_880"
				data-name="Line 880"
				x2="11.306"
				transform="translate(1576.001 329.06)"
				fill="none"
				stroke="#5a677d"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.2"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TextAlignLeftSvg',
};
</script>

<style scoped lang="scss"></style>
